module.exports = __webpack_public_path__ + "static/kartchen1-a3d8bacf520f308d32a86bd880704192.png";